var _path, _rect, _rect2, _rect3, _rect4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreateLoadStatus2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 331,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.04 11.98c.248-.248.74-.744 1.476-1.488a88.318 88.318 0 001.536-1.596c.408-.44.684-.784.828-1.032.144-.248.216-.548.216-.9 0-.24-.064-.464-.192-.672-.12-.216-.3-.388-.54-.516-.232-.136-.512-.204-.84-.204-.432 0-.78.128-1.044.384-.256.248-.424.52-.504.816L1.04 6.4a2.6 2.6 0 01.432-.792 2.54 2.54 0 01.84-.708c.352-.2.768-.3 1.248-.3.504 0 .948.108 1.332.324.392.216.696.504.912.864.216.36.324.748.324 1.164 0 .84-.44 1.708-1.32 2.604l-2.46 2.472h3.876V13H1.04v-1.02zm9.7-7.572h.949L8.125 13h-.948l3.564-8.592zm5.088 6.828h-3.936v-.768l3.84-5.676h1.104v5.484h1.056v.96h-1.056V13h-1.008v-1.764zm0-.96V6.28h-.048l-2.724 3.996h2.772z",
    fill: "#9390A0"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 22.5,
    y: 7,
    width: 65,
    height: 4,
    rx: 2,
    fill: "#07AFF0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 103.5,
    y: 7,
    width: 65,
    height: 4,
    rx: 2,
    fill: "#07AFF0"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 184.5,
    y: 7,
    width: 65,
    height: 4,
    rx: 2,
    fill: "#EFEFEF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 265.5,
    y: 7,
    width: 65,
    height: 4,
    rx: 2,
    fill: "#EFEFEF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateLoadStatus2);
export default __webpack_public_path__ + "static/media/create-load-status-2.d482cd0a1a74912e80af962b1d454869.svg";
export { ForwardRef as ReactComponent };